import React,{Component} from 'react';



class ModalComponent extends Component{
    constructor(props){
        super(props);
        this.state = {
            muestra:false
        };
  
    }

    componentWillReceiveProps(nextprops){
        console.log(nextprops);
        if(nextprops.mostrar){
            this.setState({muestra:nextprops.mostrar});
        }

      
    }


    render(){
        
        if(!this.state.muestra){
            return null
        }else{
            return (
                <div>
                    <div className="modal fade in" tabIndex="-1" style={{display:"block"}} role="dialog" >
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                            <div className="modal-header">
                                {
                                    this.props.propsModal.exito ?
                                     <label className="tituloModal">Transacción Exitosa</label> : null
                                }
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal.bind(this)}>
                                <span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body">
                             <div className="row">
                            {this.props.propsModal.exito ?
                            <div className="col-md-1 col-sm-1 col-xs-2 col-lg-1">
                                <div className="imageExitoCot" >
                                </div>
                            </div>:
                            <div className="col-md-1 col-sm-1 col-xs-2 col-lg-1">
                                <div className="imageErrorCot" >
                                </div>
                            </div>
                            }

                            <div className="col-md-10 col-sm-10 col-xs-10 col-lg-10 text-justify">
                                <p className="labelExito"><b>{this.props.propsModal.texto}</b></p>
                            </div>

                            {
                                this.props.propsModal.exito ?
                                <div className="col-md-10 col-sm-10 col-xs-10 col-lg-10 text-justify">
                                    <br/>
                                    <p className="labelExito"><i> Hasta Pronto.</i> </p>
                                </div>:null
                            }

                        </div>

                                
                            </div>
                            </div>
                        </div>
                        
                        </div>
                        <div className="modal-backdrop fade in" ></div>
                </div>
            )
        }
    }

    closeModal(event){
        this.setState({muestra:false});
    }
}

export default ModalComponent;


// WEBPACK FOOTER //
// ./src/ModalCmpt.js